import React, {useEffect, useContext} from 'react'
import {Container, Grid, Typography, MenuItem, TextField} from '@material-ui/core'
import {Query} from 'react-apollo'
import {barcodeSheetQuery} from '../../graphql/barcode/queries/barcodeSheetQuery'
import {labelWidth, labelHeight} from '../../utils/barcodeSheet'
import {useTranslation} from 'react-i18next'
import useStyles from './BarcodeCreateLabel.styles'
import BarcodeLoadingScreen from '../BarcodeLoadingScreen'
import BarcodeNavHeaderButtons from '../BarcodeNavHeaderButtons'
import {BarcodeLabelEditorContextProvider} from '../../context/BarcodeLabelEditor'
import BarcodeLabelDragArea from '../BarcodeLabelDragArea'
import BarcodeLabelDropBox from '../BarcodeLabelDropBox'
import {BarcodeSheetRecordContext} from '../../context/BarcodeSheetRecord'

function BarcodeCreateLabel(props) {
  const {barcodeSheetRecord} = useContext(BarcodeSheetRecordContext)

  const classes = useStyles()
  const {t} = useTranslation()
  const accountID = parseInt(window.localStorage.getItem('account_id'))
  const [sheetValue, setSheetValue] = React.useState(barcodeSheetRecord || '')
  const [labelValue, setLabelValue] = React.useState({
    name: '',
    width: sheetValue ? labelWidth(sheetValue) : '',
    height: sheetValue ? labelHeight(sheetValue) : '',
    unit: sheetValue
      ? sheetValue['unit'] === 'in'
        ? '(inches)'
        : sheetValue['unit'] === 'mm'
        ? '(millimeters)'
        : ''
      : '',
  })

  useEffect(() => {
    if (window !== window.parent) {
      window.parent.postMessage('scrollTop', process.env.REACT_APP_BARCODE_WINDOW_URL)
    } else {
      window.scrollTo(0, 0)
    }
  }, [])

  function sheetChange(event) {
    let sheet = event.target.value
    setSheetValue(sheet)
    let width = labelWidth(sheet)
    let height = labelHeight(sheet)
    let unit = sheet['unit']
    if (unit === 'in') unit = '(inches)'
    else if (unit === 'mm') unit = '(millimeters)'
    setLabelValue({...labelValue, width, height, unit})
  }

  function labelChange(event) {
    let name = event.target.name
    let value = event.target.value

    setLabelValue({...labelValue, [name]: value})
  }

  return (
    <div>
      <BarcodeNavHeaderButtons previous="" />
      <div>
        <BarcodeLabelEditorContextProvider>
          <Grid container>
            <Grid item xs={5} style={{paddingRight: '4rem'}}>
              <Typography variant="h6" className={classes.headerTitle}>
                {t('barcode.label.new-label.create-template')}
              </Typography>
              <Typography className={classes.headerTagLine}>
                {t('barcode.label.new-label.create-template')}
              </Typography>
              <Container>
                <Grid container>
                  <Grid container item xs={12} justify="flex-start">
                    <TextField
                      id="name"
                      label={t('barcode.label.new-label.barcode-sticker')}
                      className={classes.menuBar}
                      fullWidth={true}
                      variant="outlined"
                      name="name"
                      onChange={labelChange}
                      value={labelValue.name}
                    ></TextField>
                  </Grid>
                </Grid>
              </Container>
              <Container>
                <Grid container>
                  <Grid container item xs={12} justify="flex-start">
                    <Query query={barcodeSheetQuery} variables={{accountId: accountID}}>
                      {({loading, error, data}) => {
                        if (loading)
                          return (
                            <div>
                              <BarcodeLoadingScreen size={50} />
                            </div>
                          )
                        if (error)
                          return (
                            <div>
                              {props.history.push({
                                pathname: 'pageNotFound',
                              })}
                            </div>
                          )
                        const trueSheet = data.barcodeSheet.find(e => e.id === sheetValue.id)
                        return (
                          <TextField
                            id="outlined-select-currency"
                            select
                            label={t('barcode.label.new-label.sheet')}
                            className={classes.textField}
                            value={trueSheet}
                            onChange={sheetChange}
                            SelectProps={{
                              MenuProps: {
                                className: classes.menu,
                              },
                            }}
                            margin="normal"
                            variant="outlined"
                          >
                            {data.barcodeSheet.map(barcodeSheet => (
                              <MenuItem key={barcodeSheet.id} value={barcodeSheet}>
                                {barcodeSheet.name}
                              </MenuItem>
                            ))}
                          </TextField>
                        )
                      }}
                    </Query>
                  </Grid>
                </Grid>

                <Grid container>
                  <Grid container item xs={6} justify="flex-start">
                    <TextField
                      id="width"
                      label={`${t('barcode.label.new-label.width')} ${labelValue.unit}`}
                      className={classes.widthField}
                      fullWidth={true}
                      variant="outlined"
                      name="width"
                      value={labelValue.width}
                      disabled
                    ></TextField>
                  </Grid>
                  <Grid container item xs={6} justify="flex-start">
                    <TextField
                      id="height"
                      label={`${t('barcode.label.new-label.height')} ${labelValue.unit}`}
                      className={classes.hightField}
                      fullWidth={true}
                      variant="outlined"
                      name="height"
                      value={labelValue.height}
                      disabled
                    ></TextField>
                  </Grid>
                </Grid>
              </Container>
              <Container>
                <BarcodeLabelDragArea />
              </Container>
            </Grid>

            <Grid container item xs={7}>
              <BarcodeLabelDropBox
                labelValue={labelValue}
                sheetValue={sheetValue}
                pageFrom={props.location.pageFrom}
              />
            </Grid>
          </Grid>
        </BarcodeLabelEditorContextProvider>
      </div>
    </div>
  )
}

export default BarcodeCreateLabel
